import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { Router } from '@angular/router';
import { LookupService } from 'src/app/services/Lookup/lookup.service';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  constructor(private helper: HelperService, private lookup: LookupService) { }

  reloadPage: string;
  isAuthorized: string;

  userName: string;

  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    if (this.isAuthorized === "true") {
      this.helper.setTitle('Provider - Home');

      this.reloadPage = localStorage.getItem("reloadPage");
      if (this.reloadPage == "true") {
        localStorage.setItem("reloadPage", "false");
        location.reload();
      }
      this.lookup.getUser().subscribe(data => {
        localStorage.setItem("currentProvider", data.ProviderId);

        if (data.FirstQuestion === null && data.SecondQuestion === null) {
          alert("Please update your Secret Questions.");
          location.assign("#/sec-questions");
        }
      });
    }
    else
      location.assign("#/login-form");
  }
}